module.exports = __webpack_public_path__ + "static/img/store.44ee354.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/store.png
// module id = y2zH
// module chunks = 1